import { Box, Typography, Link } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ENV_BASE_URL } from 'src/config';
import { TRANSLATION_CONSTANTS as T } from 'src/utils/translations';

const DomainNotFoundError = () => {
  const { t } = useTranslation();
  return (
    <Box display="flex" flexDirection="column" gap={{ xs: '16px', sm: '6px' }}>
      <Typography fontSize="24px" fontWeight={500} color="primary">
        {t(T.domainNotRecognized)}
      </Typography>
      <Box display="flex" flexDirection="column" gap="8px">
        <Typography color="#000C57A2">
          {t(T.domainNotRegistered, { domain: 'intechww.empowergpt.ai' })}
        </Typography>
        <Typography color="#000C57A2">{t(T.validDomainRequired)}</Typography>
        <Typography color="#000C57A2">{t(T.checkEmailForDomain)}</Typography>
        <Typography mt={2} color="#000C57A2">
          {t(T.dontRememberDomain)}
        </Typography>
        <Typography color="#000C57A2">
          {t(T.loginFromThisLink)}{' '}
          <Link
            href={ENV_BASE_URL}
            target="_blank"
            rel="noopener noreferrer"
            color="primary"
          >
            {t(T.linkPlaceholder)}
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};

export default DomainNotFoundError;
